/* eslint-disable import/first */
import React from 'react';
import noImg from '../../assets/no-itm.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { FormattedMessage } from 'react-intl';

import { getCleanURL } from 'spwa-ui-library/esm/utils/path';

import css from './index.module.scss';
export default function CartItemCount({ src, count }) {
  return (
    <div className={css.itemsCount}>
      <div className={css.countIcon}>
        <LazyLoadImage
          src={getCleanURL(src)}
          alt="items count"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImg;
          }}
        />
      </div>
      <div className={css.counter}>
        <h5>
          <span>{count}</span>
          <span>
            {count === 1 ? (
              <FormattedMessage id="cartbar_item" defaultMessage="Item" />
            ) : (
              <FormattedMessage id="checkout_items" defaultMessage="Item" />
            )}
          </span>
        </h5>
      </div>
    </div>
  );
}
